import { render, staticRenderFns } from "./Twos.vue?vue&type=template&id=2a9e96a5&scoped=true"
import script from "./Twos.vue?vue&type=script&lang=js"
export * from "./Twos.vue?vue&type=script&lang=js"
import style0 from "./Twos.vue?vue&type=style&index=0&id=2a9e96a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e96a5",
  null
  
)

export default component.exports